var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlignmentLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(-133.329 -63.997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18551",
    "data-name": "Rectangle 18551",
    width: 30,
    height: 3,
    rx: 1.5,
    transform: "translate(133.329 63.997)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18552",
    "data-name": "Rectangle 18552",
    width: 22,
    height: 3,
    rx: 1.5,
    transform: "translate(133.329 71.997)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18553",
    "data-name": "Rectangle 18553",
    width: 30,
    height: 3,
    rx: 1.5,
    transform: "translate(133.329 79.997)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18554",
    "data-name": "Rectangle 18554",
    width: 22,
    height: 3,
    rx: 1.5,
    transform: "translate(133.329 87.997)",
    fill: "#dedede"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignmentLeft);
export default __webpack_public_path__ + "static/media/icon-alignment-left.742016d7.svg";
export { ForwardRef as ReactComponent };